// extracted by mini-css-extract-plugin
export default {"popupWrapper":"PopupWrapper_popupWrapper__hse5P"};